import NavTab from './NavTab';

export default NavTab;
